import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="bg-brand-night pb-16" data-id="element-77" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-5" data-id="element-78" data-mp="3ggkal1dq1o2p">
        <p className="text-[0.68rem] leading-snug text-white/60" data-id="element-79" data-mp="32p5mwh8vcypb">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mt-1 text-[0.64rem] leading-snug text-white/60" data-id="element-80" data-mp="36nd4feb5q41k">
          {PRODUCT_NAME}™ es un producto educativo de apoyo. Los contenidos,
          actividades, planificaciones y evaluaciones pueden requerir
          adaptación según el diseño curricular, institución, jurisdicción,
          curso y necesidades de los estudiantes. No sustituye la formación
          docente, normativa educativa ni los criterios pedagógicos
          establecidos por cada institución.
        </p>
        <p className="mt-1 text-[0.68rem] text-white/80" data-id="element-81" data-mp="29xvqkc20tbos">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-brand-yellow transition-colors duration-150 ease-out hover:text-white" data-id="element-82" data-mp="2ezuupo5l4cms">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1 flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 text-[0.68rem] text-white/80" data-id="element-83" data-mp="3gctnciul2fop">
          <a href="#terminos" className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-84" data-mp="3q7byua68rfj2">
            Términos y Condiciones
          </a>
          <span className="text-white/40" data-id="element-85" data-mp="33nlc2qvddj4">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-86" data-mp="htd2h7fcxs51">
            Política de Privacidad
          </a>
          <span className="text-white/40" data-id="element-87" data-mp="qt8fziwdxz88">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-out hover:text-brand-yellow" data-id="element-88" data-mp="qu1drudd9ee8">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}